import styled from 'styled-components';

export const RelativeDiv = styled.div`
  position: relative;
  &.cartFlex {
    display: flex;
    gap: 10px;
    align-items: center;
  }
`;

export const BabyDescSection = styled.div`
  margin: 30px 0;
  position: relative;

  @media (max-width: 720px) {
    margin: 20px 0;
  }
`;

export const WeekListStyle = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 12px 0 0;

  li {
    padding: 8px 0;
    text-decoration: underline;
    color: #2b939f;
    font-size: clamp(12px, 2vw, 15px);
    font-weight: 500;
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      margin-right: 4px;
      height: 16px;
      width: 16px;
    }

    @media (max-width: 720px) {
      padding: 8px 10px;
    }
  }
`;

export const BabyImage = styled.img`
  width: 100%;
  margin-bottom: 28px;
  height: 100%;
`;

export const DescriptionPara = styled.div`
  font-size: 15px;
  color: hsl(0deg, 0%, 0%, 87%);
  padding: 16px 10px 0;

  ul {
    list-style: disc;
    padding: 0 8px;
    @media (max-width: 720px) {
      padding: 0 20px;
    }
    li {
      padding: 4px 0;
    }
  }
`;

export const BabyDescriptionPoint = styled.ul`
  margin: 16px 0;

  li {
    padding: 10px 18px;
    display: flex;
    align-items: flex-start;
    font-size: 15px;
    color: hsl(0deg, 0%, 0%, 87%);
    img {
      margin-right: 4px;
    }
  }
`;

export const HelpfulArticle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: hsl(0deg, 0%, 0%, 6%);
  padding: 12px 16px;
  margin-top: 14px;
  font-size: 14px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 80%);
  p {
    color: #0000006e;
  }
  img {
    width: 20px;
    height: 20px;
  }

  div {
    display: flex;
    align-items: center;
    column-gap: 4px;
    cursor: pointer;

    .yes {
      margin-right: 16px;
    }
  }
`;
export const IframeVideo = styled.iframe`
  width: 100%;
  margin: auto;
  max-width: ${(props) => (props.homeVideo ? 'unset' : '800px')};
  margin-bottom: ${(props) =>
    props.stroller || props.catPage ? '0' : props.topic ? '16px' : '28px'};
  height: auto;
  max-height: ${(props) =>
    props.topic ? '120px' : props.homeVideo ? 'unset' : '420px'};
  aspect-ratio: ${(props) =>
    props.homeVideo ? '28/16' : props.topic ? 'auto' : '16/16'};
  min-height: ${(props) => (props.topic ? '120px' : '200px')};

  @media (max-width: 720px) {
    aspect-ratio: auto;
  }
`;
export const Feedback = styled.div`
  padding: 8px;
  font-weight: 500;
  color: rgb(0 0 0 / 83%);
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
`;
